import { commonjsGlobal as o } from "./main9.js";
var e = typeof o == "object" && o && o.Object === Object && o, a = e;
export {
  a as _
};
